module.exports = __webpack_public_path__ + "static/img/logo_YE.bb8bb0bc.png";